import type { Props } from '../type';
import { SVGOutlinedIcon } from './SVGOutlinedIcon';

export const CheckCircleOutlinedIcon = (props: Props) => (
  <SVGOutlinedIcon color="#22A075" {...props}>
    <path
      d="M6 13.223L8.45 16.7C8.63855 16.9817 8.95158 17.1549 9.29037 17.165C9.62916 17.1751 9.95197 17.0209 10.157 16.751L18 6.828"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 23.249C18.2132 23.249 23.25 18.2122 23.25 11.999C23.25 5.78579 18.2132 0.748993 12 0.748993C5.7868 0.748993 0.75 5.78579 0.75 11.999C0.75 18.2122 5.7868 23.249 12 23.249Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SVGOutlinedIcon>
);
